var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"environment-widget"},[(_vm.environment === 'development')?_c('div',{staticClass:"widget-content"},[_vm._v(" Development ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }